import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadCorridorTemplate } from "store/state/cashflows";

const DownloadCorridorTemplate = props => (
  <SecondaryButton onClick={() => props.downloadCorridorTemplate({ hedgeId: props.hedgeId })}>Corridor Template</SecondaryButton>
);

export default connect(null, {
  downloadCorridorTemplate
})
(DownloadCorridorTemplate);
